export const fluentExperiments = {
  fluentV9RibbonButtonIsEnabled: "SharedOnline.FluentV9RibbonButtonEnabled",
  fluentV9ButtonIsEnabled: "FluentV9ButtonBRSIsEnabled",
  fluentV9CompoundButtonIsEnabled: "SharedOnline.FluentV9CompoundButtonEnabled",
  fluentV9CheckboxIsEnabled: "SharedOnline.FluentV9CheckboxEnabled",
  // Flight to enable the Fluent V9 status bar in Excel
  fluentV9StatusBarButtonEnabled: "SharedOnline.FluentV9StatusBarButtonEnabled",
  fluentV9InputComboboxIsEnabled: "SharedOnline.FluentV9InputComboboxEnabled",
  fluentV9PersonaButtonIsEnabled:
    "SharedOnline.ChangeGate.FluentV9PersonaButtonEnabled",
  fluentV9ContextMenuIsEnabled: "SharedOnline.FluentV9ContextMenuEnabled",
  fluentV9FloatieIsEnabled: "SharedOnline.FluentV9FloatieEnabled",
  fluentV9MessageBarIsEnabled: "SharedOnline.FluentV9MessageBarEnabled",
  fluentV9ToggleIconEnabled:
    "SharedOnline.ChangeGate.FluentV9ToggleIconEnabled",
  fluentV9RibbonIconPreviewGalleryIsEnabled:
    "SharedOnline.FluentV9RibbonIconPreviewGalleryEnabled",
  fluentV9RibbonFontStyleGalleryIsEnabled:
    "SharedOnline.FluentV9RibbonFontStyleGalleryEnabled",
  fluentV9TabListSpinButtonFocusIsEnabled:
    "SharedOnline.FluentV9TabSpinFocusIsEnabled",
  fluentV9TaskPaneIsEnabled: "SharedOnline.FluentV9TaskPaneIsEnabled",
  fluentV9DialogIsEnabled: "SharedOnline.FluentV9DialogEnabled",
  fluentV9RibbonControlsIsEnabled:
    "SharedOnline.FluentV9RibbonControlsIsEnabled",
  fluentV9ShortcutPillsIsEnabled: "SharedOnline.FluentV9ShortcutPillsIsEnabled",
  fluentV9HeaderButtonIsEnabled:
    "SharedOnline.ChangeGate.FluentV9HeaderButtonEnabled",
  newV9RibbonMenuEnabled: "SharedOnline.NewV9RibbonMenuEnabled",
  // Change gate to enable the fluent v9 status bar button in Word, PPT and Visio
  fluentV9StatusBarButtonInWordPPTVisioEnabled:
    "SharedOnline.ChangeGate.FluentV9StatusBarButtonInWordPPTVisioEnabled",
  disableFluentV9StatusBar: "DisableVNextStatusBar",
  fluentV9TooltipIsEnabled: "SharedOnline.fluentV9TooltipIsEnabled",
  fluentV9SearchBoxIsEnabled: "SharedOnline.fluentV9SearchBoxIsEnabled",
  fluentV9StackIsEnabled: "SharedOnline.FluentV9StackEnabled",
  fluentV9IconIsEnabled: "SharedOnline.FluentV9IconEnabled",
  fluentV8FileMenuHeadlessThemeIsEnabled:
    "SharedOnline.FluentV8FileMenuHeadlessThemeEnabled",
  fluentV9TableStylesPreviewGalleryIsEnabled:
    "SharedOnline.FluentV9TableStylesPreviewGalleryEnabled",
};
